import { compose, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { createAction, handleActions } from 'redux-actions';
import { get, isEqual } from 'lodash';

export const syncPropStateToRedux = createAction('@@SYNC_PROP_STATE_TO_REDUX/SYNC');

const initialState = {};

export const reducer = handleActions({
  [syncPropStateToRedux]: (state, { payload: { propName, value } }) => ({
    ...state,
    [propName]: value,
  }),
}, initialState);

const withPropStateSyncToRedux = (
  propName,
  propNameInStore,
  actionCreator = syncPropStateToRedux,
) => {
  const userActionCreator = typeof propNameInStore === 'function'
    ? propNameInStore
    : actionCreator;
  const userPropNameInStore = typeof propNameInStore === 'string'
    ? propNameInStore
    : propName;
  let lastValue;
  return compose(
    connect(),
    lifecycle({
      componentDidUpdate() {
        const value = get(this.props, propName);
        if (!isEqual(lastValue, value)) {
          this.props.dispatch(userActionCreator({ propName: userPropNameInStore, value }));
          lastValue = value;
        }
      },
    }),
  );
};

export default withPropStateSyncToRedux;



// WEBPACK FOOTER //
// ./src/hoc/withPropStateSyncToRedux.js